<div class="layout-content">
	<!--ALL TASK-->
	<div class="grid">
		<div class="col-12 pt-0">
			<p-table dataKey="Id" [value]="invitationsList" [paginator]="true" [totalRecords]="resultLength"
				[loading]="loading" [rows]="pageSize" [showCurrentPageReport]="true"
				currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true" sortField="updated_at"
				[sortOrder]="-1" responsiveLayout="stack">
				<ng-template pTemplate="header">
					<tr>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'TYPE' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'INVITATION_DETAILS' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'SENDER' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'SENDER_EMAIL' | translate }}
							</div>
						</th>
						<!-- ACTIONS BUTTONS -->
						<th></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-invitation>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'TYPE' | translate }}</span>
							<div class="flex align-items-center justify-content-center gap-2">
								<div [class]="getInvitationsTypeIcon(invitation)" class="text-lg"></div>
								<div>{{ getInvitationsTypeTxt(invitation) | translate | truncate:[30]}}</div>
							</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'INVITATION_DETAILS' | translate }}</span>{{
							getInvitationsDetails(invitation) }}
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'SENDER' | translate }}</span>
							<p-tag [icon]="getSenderTypeIcon(invitation)" [value]="invitation.CreatorFirstName + ' ' + invitation.CreatorLastName | translate | truncate:[32]"
									[severity]="getSenderSeverity(invitation)"></p-tag>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'SENDER_EMAIL' | translate }}</span>
							{{ invitation.CreatorEmail | truncate:[32] }}
						</td>
						<td>
							<div class="flex flex-row justify-content-center align-items-center gap-1" [class]="underTablet() ? 'w-full' : ''">
								<button type="button" pButton pRipple label="{{ 'ACCEPT' | translate }}"
									class="p-button-success font-normal" (click)="acceptInvite(invitation)"
									icon="pi cm-check">
								</button>
								<button type="button" pButton pRipple label="{{ 'REJECT' | translate }}"
									class="p-button-danger font-normal" (click)="rejectInvite(invitation)"
									icon="pi cm-cancel">
								</button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>

	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
			class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1" [ngClass]="dynamicButtonWidth()">
		</button>
	</div>

	<p-confirmDialog #confDialog>
		<ng-template pTemplate="footer">
			<div class="col-12 flex justify-content-center">
				<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
					(click)="confDialog.accept()">
				</button>
				<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
					(click)="confDialog.reject()">
				</button>
			</div>
		</ng-template>
	</p-confirmDialog>
</div>